import BezierEasing from 'bezier-easing';

export const cubicBezierEasingFn = BezierEasing(0.23, 1, 0.32, 1);

export const STANDARD_TIMING_FUNCTION = 'cubic-bezier(0.23, 1, 0.32, 1)';
export const STANDARD_DURATION = '500ms';
const STANDARD_DELAY = '0s';
export const STANDARD_TRANSITION = `${STANDARD_DURATION} ${STANDARD_TIMING_FUNCTION}`;
type AnimationTransitionConfig = {
  duration?: string;
  timingFunction?: string;
  delay?: string;
};

type AnimationTransitionArgs = [...properties: string[]] | [...properties: string[], config: AnimationTransitionConfig];

export function animationTransition(...args: AnimationTransitionArgs): string {
  let properties: string[] = [];
  let config: AnimationTransitionConfig = {};

  if (typeof args[args.length - 1] !== 'string') {
    config = args.pop() as AnimationTransitionConfig;
    properties = args as string[];
  } else {
    properties = args as string[];
  }

  if (!properties.length) {
    throw new Error('Must pass one property to transition');
  }

  const duration = config.duration || STANDARD_DURATION;
  const timingFunction = config.timingFunction || STANDARD_TIMING_FUNCTION;
  const delay = config.delay || STANDARD_DELAY;

  return properties.map(property => `${property} ${duration} ${timingFunction} ${delay}`).join(', ');
}

export interface TransitionProps {
  property: string;
  delay?: string;
  duration?: string;
  timingFunction?: string;
}

export const animationTransitionExt = (...transitions: Array<TransitionProps>) => {
  if (!transitions) {
    throw new Error('Must pass one property to transition');
  }
  return transitions
    .map(({ property, duration, delay, timingFunction }) => {
      duration = duration || STANDARD_DURATION;
      delay = delay || STANDARD_DELAY;
      return `${property} ${duration} ${timingFunction || STANDARD_TIMING_FUNCTION} ${delay}`;
    })
    .join(', ');
};
